import React from 'react';
import { useSelector } from 'react-redux';
import FA from 'react-fontawesome';
import PropTypes from 'prop-types';

/**
 * ボタンローディングコンポーネント
 */
const GlobalLoading = (props) => {
  const loadingState = useSelector((state) => state.loading);
  // ローディングがセットされていれば表示する
  return (
    <span>
      <FA name="refresh" className={loadingState.buttonLoading && loadingState.buttonLoading[props.buttonName] ? 'loading' : ''} />
    </span>
  );
};

GlobalLoading.propTypes = {
  buttonName: PropTypes.string
};

export default GlobalLoading;